// extracted by mini-css-extract-plugin
module.exports = {"body":"Result_body__1GmoP","title":"Result_title__2oNVU","descr":"Result_descr__11v8V","icon":"Result_icon__1PDHl"};